export default {
  listLabel: {
    footerText1:
      'Giá: x 1,000. Khối Lượng: x 1,000. Giá Trị: x 1,000,000. Ngày được đánh dấu sao là Ngày Thực Hiện.',
    footerText2: 'Giá: x 1,000. Khối Lượng: x 1,000. Giá Trị: x 1,000,000',
  },

  tab: {
    LastWeek: 'Tuần Trước',
    LastMonth: 'Tháng Trước',
    ThisWeek: 'Tuần Này',
    ThisMonth: 'Tháng Này',
    NextWeek: 'Tuần Sau',
    NextMonth: 'Tháng Sau',
  },

  listFilterEvent: {
    ern: 'ERN',
    div: 'DIV',
    sis: 'SIS',
    ipo: 'LIS',
    agm: 'AGM',
  },

  listFilterEventTooltip: {
    ern: 'Lợi Nhuận',
    div: 'Cổ Tức',
    sis: 'Phát Hành Cổ Phiếu',
    ipo: 'Niêm Yết',
    agm: 'Đại Hội Cổ Đông Thường Niên',
  },

  marketCarlendarErnTable: {
    //ern
    TICKER: 'MÃ',
    COMPANY: 'DOANH NGHIỆP',
    REVENUE: 'DOANH THU(TỶ)',
    REV: 'DOANH THU (TỶ)<br> (DỰ BÁO)',
    PROFIT: 'LỢI NHUẬN (TỶ)',
    PROFIT_FORECAT: 'LỢI NHUẬN (TỶ)<br> (DỰ BÁO)',
    PERFORMANCE: 'BIẾN ĐỘNG',
    INTERIM: 'Báo cáo',
  },

  marketCarlendarDivCashTable: {
    TICKER: 'MÃ',
    AN_DATE: 'NGÀY THÔNG BÁO',
    EX_RIGHT_DATE: 'NGÀY GDKHQ',
    RECORD_DATE: 'NGÀY ĐKCC',
    PAYOUT_DATE: 'NGÀY CHI TRẢ',
    EX_RATIO: 'TỶ LỆ',
    VALUE: 'GIÁ TRỊ',
    DIV_YEAR: 'NĂM',
    DIV_TYPE: 'KỲ TRẢ',
    PERFORMANCE: 'BIẾN ĐỘNG',
    REFERENCE: 'THAM CHIẾU',
  },

  marketCarlendarDivStockTable: {
    TICKER: 'MÃ',
    AN_DATE: 'NGÀY THÔNG BÁO',
    EX_RIGHT_DATE: 'NGÀY GDKHQ',
    RECORD_DATE: 'NGÀY ĐKCC',
    PAYOUT_DATE: 'NGÀY CHI TRẢ',
    EX_RATIO: 'TỶ LỆ CHI TRẢ',
    DIV_YEAR: 'NĂM',
    DIV_TYPE: 'KỲ TRẢ',
    PERFORMANCE: 'BIẾN ĐỘNG',
    REFERENCE: 'THAM CHIẾU',
  },

  marketCarlendarSisTable: {
    TICKER: 'MÃ',
    ANNOUNCEMENT_DATE: 'NGÀY THÔNG BÁO',
    EX_RIGHTS_DATE: 'GDKHQ',
    ISSUE_DATE: 'NGÀY PHÁT HÀNH',
    LISTING_DATE: 'NGÀY NIÊM YẾT',
    ISSUE_METHOD: 'HÌNH THỨC PHÁT HÀNH ',
    ISSUE_PERCEN: 'TỶ LỆ PHÁT HÀNH',
    ISSUE_VOLUMN: 'KHỐI LƯỢNG PHÁT HÀNH',
    YEAR: 'NĂM',
    STATUS: 'TÌNH TRẠNG',
  },

  marketCarlendarIpoTable: {
    TICKER: 'MÃ',
    COMPANY: 'DOANH NGHIỆP',
    AN_DATE: 'NGÀY THÔNG BÁO',
    LISTING_DATE: 'NGÀY NIÊM YẾT',
    EXCHANGE: 'SÀN',
    OFFERING_SHARES: 'LƯỢNG CHÀO BÁN',
    IPO_RATIO: 'TỶ LỆ CHÀO BÁN',
    PRICE: 'GIÁ',
    REVIPO: 'DOANH THU (TỶ)',
    PROFIT: 'LỢI NHUẬN (TỶ)',
  },

  marketCarlendarAgmTable: {
    TICKER: 'MÃ',
    COMPANY: 'DOANH NGHIỆP',
    DATE: 'NGÀY THÔNG BÁO',
    EX_DIV_DATE: 'NGÀY GDKHQ',
    VENUE: 'NƠI TỔ CHỨC',
    LOCATION: 'ĐỊA ĐIỂM',
    SOURCE: 'NGUỒN',
  },

  marketCarlendarLisTable: {
    TICKER: 'MÃ',
    COMPANY: 'DOANH NGHIỆP',
    AN_DATE: 'NGÀY THÔNG BÁO',
    RECORD_DATE: 'NGÀY ĐKCC',
    EX_RIGHT_DATE: 'NGÀY GDKHQ',
    EXERCISE_DATE: 'NGÀY THỰC HIỆN',
    LISTING_TYPE: 'LOẠI NIÊM YẾT',
    PERFORMANCE: 'BIẾN ĐỘNG',
  },

  tableTitle: {
    cashDividend: 'CỔ TỨC TIỀN MẶT',
    stockDividend: 'CỔ TỨC CỔ PHIẾU',
    newListing: 'NIÊM YẾT MỚI',
    otherListing: 'NIÊM YẾT KHÁC',
  },

  timeRange: 'Phạm vi',
  timeRangeFilter: {
    from: 'Từ',
    to: 'Đến',
  },
  lastestQuarter: 'Quý gần nhất',
  forecastForCurrentYear: 'Dự báo KQ năm hiện tại',
};
